import {
    PARTICIPANT_POST_FAILURE,
    PARTICIPANT_POST_REQUEST,
    PARTICIPANT_POST_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const postReducer = (state = initialState, action) => {
    const {type, participant} = action;
    switch (type) {
        case PARTICIPANT_POST_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
            participant,
        }}

        case PARTICIPANT_POST_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case PARTICIPANT_POST_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
